module.exports = __webpack_public_path__ + "static/media/react native.26d5318f.svg";